import mixpanel from 'mixpanel-browser';
import { getInitialDevice } from './device';

const TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN;
// 在 OIDC silent refresh 的隱藏 iframe 中停用 Mixpanel：
// oidc-client 的 signinSilent() 會在 window.innerWidth = 0 的隱藏 iframe 載入完整 App，
// 若不停用會導致 Device = 'Mobile' 的雜訊事件持續寫入 Mixpanel。
const IS_ENABLED = !!TOKEN && window.self === window.top;

export function initMixpanel() {
  if (!IS_ENABLED) return;
  mixpanel.init(TOKEN, {
    ip: false,
    persistence: 'localStorage',
    debug: process.env.NODE_ENV === 'development',
  });
}

// Device: 裝置類型（'Mobile' | 'Pad' | 'PC'），在 initMixpanel 後立即設定
// MemberId 在登入後透過 identifyUser 設定
export function registerSuperProperties(props) {
  if (!IS_ENABLED) return;
  mixpanel.register(props);
}

// 登入後呼叫一次：綁定 userId 並設定 MemberId super property
export function identifyUser(userId) {
  if (!IS_ENABLED || !userId) return;
  mixpanel.identify(String(userId));
  mixpanel.register({ MemberId: userId });
}

// 登出時呼叫，清除所有 super properties 與 anonymous ID。
// mixpanel.reset() 會清除所有 super properties（含 Device），
// 因此內部立即補回 Device，呼叫端無需額外處理。
export function resetUser() {
  if (!IS_ENABLED) return;
  mixpanel.reset();
  mixpanel.register({ Device: getInitialDevice() });
}

export function trackEvent(eventName, properties = {}) {
  if (!IS_ENABLED || !eventName) return;
  try {
    mixpanel.track(eventName, properties);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[Mixpanel] track failed:', error);
  }
}

export default {
  init: initMixpanel,
  register: registerSuperProperties,
  identify: identifyUser,
  reset: resetUser,
  track: trackEvent,
};
